<!--
[TASK-148] 과금내역 > 미결제 과금건 선택 일괄 재결제 > 선택 바
 - 선례 : bank-deposit-request/main.vue (선택 바) + cancel.vue (작업 모달)
 - 컨트롤러를 따로 사용하지 않고, 컨트롤러의 기능을 mixin 상속받음
 - 총괄/회원사 과금내역 목록 공용 (blade : components/billing-retry-batch.blade.php)
------------------------------------
-->
<template>
    <div
        class="bg-white"
        :uk-sticky="stickyLayout"
    >
        <!-- 선택된 아이템이 없을 때는 아무것도 표시하지 않는다 (2026-10-01 사용자 지시 — 선택 안내 문구 제거) -->

        <!-- 선택작업 -->
        <div v-show="itemChecked" class="p-0d5rem bg-sky-50 border border-sky-600">
            <div class="uk-flex uk-flex-between uk-flex-middle">
                <!-- 선택개수안내 -->
                <div class="uk-position-relative w-30rem h-2rem">
                    <div class="selected-msg uk-position-absolute " v-html="itemCheckedInfo"></div>
                </div>

                <!-- 선택 합계 -->
                <div class="mr-1rem">
                    선택 합계 <strong class="uk-text-primary">{{ checkedTotalAmountText }}</strong> 원
                </div>

                <button
                    class="uk-button uk-button-small uk-button-white mr-1rem billing-retry-open"
                    type="button"
                    :disabled="disabled"
                    v-on:click="openRetry()"
                    title="선택한 미결제 과금건을 현재 기본 결제수단으로 재결제합니다."
                >
                    <i class="material-icons">payment</i>
                    선택 건 일괄 재결제
                </button>

                <div class="uk-width-expand"></div>
            </div>
        </div>

        <!-- 일괄 재결제 모달 -->
        <retry
            ref="retry"
            :batch="batch"
            :csrfToken="csrfToken"
            :retryLimit="retryLimit"
            :showUserNick="showUserNick"
            :settingUrl="settingUrl"
        ></retry>

    </div>

</template>

<script>
import checkedCountable from '../../checked-countable';
import stickiable from '../../stickable';
export default {
    mixins: [
        checkedCountable,
        stickiable,
    ],
    components: {
        'retry': require('./retry.vue').default,
    },
    props: {
        /**
         * 일괄기능 공유data (상세정의는 컨트롤러 BatchJsonTrait 참고)
         */
        batch: Object,

        // csrf-token
        csrfToken: String,

        // 1회 처리 상한 건수 (클라이언트 가드)
        retryLimit: {
            type: Number,
            default: 50
        },

        // 회원사 열 표시 여부 (총괄 목록만 true)
        showUserNick: {
            type: Boolean,
            default: false
        },

        // 결제수단 관리 화면 링크 (회원사 화면만 전달)
        settingUrl: {
            type: String,
            default: null
        },
    },
    data: function () {
        return {
        };
    },
    computed: {
        // 작업 버튼 비활성화 여부
        disabled() {
            // 선택된 아이템없으면 비활성화
            return this.itemCheckedCount === 0;
        },

        // 스티키 레이아웃 적용여부
        stickyLayout() {
            return this.onSticky && this.itemChecked;
        },

        // 선택 합계 금액 (표시용)
        checkedTotalAmountText() {
            let total = _.sumBy(this.checkedItems, (item) => Number(item.total_amount) || 0);
            return total.toLocaleString();
        },
    },
    methods: {
        // 일괄 재결제 모달 열기 (상한 초과 선택은 모달을 열기 전에 차단)
        openRetry() {
            if (this.itemCheckedCount > this.retryLimit) {
                alert('한 번에 최대 ' + this.retryLimit + '건까지 재결제할 수 있습니다. (현재 ' + this.itemCheckedCount + '건 선택) 선택 건수를 줄여 주세요.');
                return;
            }
            this.$refs['retry'].jobInit();
        },
    }
}
</script>

